import { FC, useCallback } from "react";
import { Stack } from "@mui/material";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import {
  initiateCurrentIntegration,
  IntegrationType,
  IntegrationTypeWithoutWebhook,
} from "@/store/integrations/integrationsSlice";
import { masterGridResourceTypeSelector } from "@/store/resources-grid/selectors/grid/masterGridResourceTypeSelector";
import { LiveUsageMgmtToolbarRowIntegrationAction } from "@/components/pages/live-usage-mgmt/components/resources-area/toolbar/actions/LiveUsageMgmtToolbarRowIntegrationAction";
import { differentResourceTypesSelectedOnOneGrid } from "@/store/resources-grid/selectors/grid/selection/differentResourceTypesSelectedOnOneGrid";
import { integrationOptions } from "@/components/pages/common/resources-ag-grid/components/column-defs/grid-components/actions/integrations/IntegrationMenuItems";
import { selectedResourcesLengthByMasterIdSelector } from "@/store/resources-grid/selectors/grid/selection/checkers/selectedResourcesLengthByMasterIdSelector";

interface K8SLiveUsageResourceGridToolbarQuickActionsProps {
  masterGridId: string;
}

export const K8SLiveUsageResourceGridToolbarQuickActions: FC<
  K8SLiveUsageResourceGridToolbarQuickActionsProps
> = ({ masterGridId }) => {
  const dispatch = useAppDispatch();

  const masterResourceType = useAppSelector((state) =>
    masterGridResourceTypeSelector(state, masterGridId),
  );
  const differentResourceTypesSelected = useAppSelector((state) =>
    differentResourceTypesSelectedOnOneGrid(state, masterGridId),
  );
  const selectedResourcesLength = useAppSelector((state) =>
    selectedResourcesLengthByMasterIdSelector(state, masterGridId),
  );

  const disabled = !selectedResourcesLength || differentResourceTypesSelected;

  const integrationIconClickHandler = useCallback(
    (type: IntegrationType) => {
      if (!masterResourceType) {
        return;
      }

      dispatch(
        initiateCurrentIntegration({
          type,
          resourceType: masterResourceType,
          provider: "kubernetes",
        }),
      );
    },
    [dispatch, masterResourceType],
  );

  return (
    <Stack
      bgcolor="grey.100"
      spacing={0.5}
      direction="row"
      p={0.5}
      alignItems="center"
      borderRadius={2}
    >
      {integrationOptions.map(({ type }) => {
        if (type === "jira") {
          return null;
        }

        return (
          <LiveUsageMgmtToolbarRowIntegrationAction
            key={type}
            type={type as IntegrationTypeWithoutWebhook}
            onClick={integrationIconClickHandler}
            disabled={disabled}
          />
        );
      })}
    </Stack>
  );
};
